(ns web3.lazy
  (:require [web3.view :as v]
            [shadow.lazy :as lazy]
            [kitchen-async.promise :as p]
            [reagent.core :as r]
            [web3.components.progress :as progress])
  (:require-macros web3.lazy))

(defn lazy? [x] (satisfies? lazy/ILoadable x))

(defprotocol ILoad
  (load [x]))

(extend-type lazy/Loadable
  ILoad
  (load [x] (lazy/load x)))

(deftype LoadableLookup [loadable lookup]
  lazy/ILoadable
  (ready? [_] (lazy/ready? loadable))
  ILoad
  (load [_] (load loadable))
  IDeref
  (-deref [_] (lookup @loadable)))

(defn loadable-lookup
  "Wrap loadable `x` with lookup function `lookup`"
  [x lookup]
  (if (lazy? x)
    (LoadableLookup. x lookup)
    (lookup x)))

(defn load-lazy
  "Returns value of `x` or, if it is not ready, a promise resolving to its value."
  [x]
  (cond (not (satisfies? lazy/ILoadable x)) x
        (lazy/ready? x) @x
        :else
        (p/do
          (load x)
          @x)))

(defn wrap-view
  "Wraps a possibly-lazy view to show a fallback/loader while it is loading.

  When the view is loaded, it is rendered directly without any wrapping component."
  ([view] (wrap-view view [progress/indeterminate]))
  ([view fallback]
   (let [state (r/atom nil)]
     (cond (not (satisfies? lazy/ILoadable view))
           view
           (lazy/ready? view)
           @view
           :else
           (fn [& _]
             (let [fallback-threshold 150]
               (reset! state :before-threshold)
               (p/do (lazy/load view)
                     (swap! state :loaded))
               (p/do (p/timeout fallback-threshold)         ;; wait before showing loader
                     (when (= :before-threshold @state)
                       (reset! state :loading)))
               (when (= :loading @state)
                 fallback)))))))

(defn promise-view
  "Resolves promise and renders its return value, with customizable :loading-view and :error-view."
  [promise & [{:keys [loading-view
                      error-view]
               :or {loading-view [progress/indeterminate]
                    error-view (fn [_] [:div "Oops, an error occurred!"])}}]]
  (let [{:keys [state]} (r/current-component)
        [promise-state value] @state]
    (when (nil? promise-state)
      (reset! state [:loading nil])
      (p/try (p/let [x promise]
               (reset! state [:complete x]))
             (p/catch :default e
               (reset! state [:error e]))))
    (case promise-state
      :complete value
      :error [error-view value]
      (:loading nil) loading-view)))


